<template>
    <!-- 工人报表日详情,展示打卡记录列表 -->
    <div class="rzy-page">
        <el-table :data="workerDetails" :header-cell-style="{'text-align':'center'}" id="workDetailsTable"
            :cell-style="{'text-align':'center','padding':'0px'}" border stripe max-height="600"
            @cell-dblclick="tableDbEdit">
            <el-table-column v-for="(obj,key,index) in detailKey" :key="index" :label="obj.value" :prop="key"
                :width="obj.width" />
            <!-- <el-table-column label="操作">
          <template slot-scope="data">
            <el-link type="primary" @click="showIngnoredMsg(data.row,data.$index)"
              v-show="!data.row.isIgnored">
              设为无效
            </el-link>
          </template>
        </el-table-column> -->
        </el-table>
    </div>
</template>

<script>
    import api from '@/api/factory/statistics/worker'
    export default {
        data() {
            return {
                inputInfo: '',
                workerDetails: [],
                detailKey: {
                    username: {
                        value: '姓名',
                        width: '80'
                    },
                    cardNumber: {
                        value: '卡号',
                        width: '100'
                    },
                    machineNumber: {
                        value: '机台号',
                        width: '70'
                    },
                    machineWorkShop: {
                        value: '车间',
                        width: '70'
                    },
                    workOrderNumber: {
                        value: '工单编号',
                        width: '120'
                    },
                    timeConsuming: {
                        value: '总工时',
                        width: '80'
                    },
                    // isIgnoredTip: { value: '是否无效', width: '80' },

                    validTime_change: {
                        value: '有效工时',
                        width: '80'
                    },
                    poweronRate: {
                        value: '开机率',
                        width: '80'
                    },

                    dataType: {
                        value: '数据来源',
                        width: '80'
                    },
                    startTime: {
                        value: '上机时间',
                        width: ''
                    },
                    endTime: {
                        value: '下机时间',
                        width: ''
                    }
        
      }
            }
        },
        methods: {
            // 表格双击事件监听,用于修改上下机时间
            tableDbEdit(row, column, cell, event) {
                if (column.label === '上机时间' || column.label === '下机时间') {
                    const beforeVal = event.target.innerText
                    event.target.innerHTML = ''
                    const cellInput = document.createElement('input')
                    cellInput.value = beforeVal
                    cellInput.setAttribute('type', 'text')
                    cellInput.style.width = '100%'
                    cellInput.style.textAlign = 'center'
                    cell.appendChild(cellInput)
                    cellInput.focus()
                    const _this = this
                    cellInput.onblur = function() {
                        if (beforeVal === cellInput.value) {
                            cell.removeChild(cellInput)
                            event.target.innerHTML = cellInput.value
                            return
                        }
                        _this.setClockInTime(row, cellInput.value, column.property).then(res => {
                            cell.removeChild(cellInput)
                            event.target.innerHTML = cellInput.value
                            _this.$message.success('修改成功！')
                        }, rej => {
                            cell.removeChild(cellInput)
                            event.target.innerHTML = beforeVal
                        })
                    }
                }
            },
            // 修改上下机时间
            setClockInTime(row, afterVal, property) {
                var requestObj = {
                    id: row.id,
                    startTime: new Date(row.startTime).getTime(),
                    endTime: new Date(row.endTime).getTime()
                }
                // 将修改后的值传入
                requestObj[property] = new Date(afterVal).getTime()
                return this.$requestBase({
                    url: 'v1/factory/worker/working_time/change',
                    method: 'get',
                    params: requestObj
                })
            },
            // 获取工人日打卡记录
            getworkerDetails() {
                const role = this.$route.params.role
                const workerId = this.$route.params.id
                const time = this.$route.params.time
                const startTime = this.utils.getDayStart(time)
                const endTime = this.utils.getDayEnd(time)
                api.getDetails({
                    role,
                    workerId,
                    startTime,
                    endTime
                }).then(res => {
                    this.workerDetails = this.formatWorkerDetails(res.data)
                })
            },
            // 格式化工人日打卡记录
            formatWorkerDetails(res) {
                res.forEach(item => {
					//250902 hcy说直接用totalTime -sta
                    // item.timeConsuming = this.utils.milliToHour(item.endTime - item.startTime)
					item.timeConsuming =  (item.totalTime/ 3600) .toFixed(2) //秒转小时
					//250902 hcy说直接用totalTime -end
                    item.validTime_change = (item.validTime/ 3600) .toFixed(2) //秒转小时
                    item.poweronRate = (item.validTime_change/item.timeConsuming *100).toFixed(2) + '%'
                    
                    item.startTime = this.utils.timestampToTime(item.startTime)
                    item.endTime = this.utils.timestampToTime(item.endTime)
                    // item.isIgnoredTip = item.isIgnored ? '是' : '否'
                    item.dataType = this.$enum.dataType[this.utils.formatEnum(item.dataType)[0]]
                })
                return res
            },
            // 设置忽略，现不使用
            setIgnored(row, index) {
                this.$requestBase({
                    url: 'v1/factory/worker/working_time/set/ignore',
                    method: 'GET',
                    params: {
                        id: row.id
                    }
                }).then(res => {
                    this.$Message.success('操作成功!')
                    this.workerDetails[index].isIgnored = true
                    this.workerDetails[index].isIgnoredTip = '是'
                })
            },
            // 设置忽略提示，现不使用
            showIngnoredMsg(row, index) {
                this.$confirm('是否将这条打卡记录设为无效，请谨慎操作。', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(res => {
                    this.setIgnored(row, index)
                }).catch(() => {})
            }
        },
        created() {
            this.getworkerDetails()
        }
    }
</script>
<style scoped>
    .el-input.el-input__inner {
        text-align: center;
    }
</style>
